import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { appLayoutRoute } from '@/app/routes/roots';
import { validateOffboardingSearch } from './lib/offboardingSearch';

/**
 * One route, with the selected offboarding as a search param.
 *
 * `/offboarding?id=…`, matching how onboarding is routed. There is no `tab`
 * here because the four steps are stacked sections on one page rather than
 * tabs — the whole record arrives in one request and is shown at once.
 */
export const offboardingRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/offboarding',
  component: lazyRouteComponent(
    () => import('./pages/OffboardingPage'),
    'OffboardingPage',
  ),
  validateSearch: validateOffboardingSearch,
});

export const offboardingRoutes = [offboardingRoute];
